import { useCallback, useContext, useState } from 'react';

import { PairWalletsContext } from 'context/PairWalletsContext/PairWalletsContext';
import { ModalTransferWizard } from 'features/transfer/ui/ModalTransferWizard';
import {
  ConnectNewWalletsToPairModal,
  DepositWithdrawModal,
  DisconnectWalletsFromPairModal,
  ManualTxsModal,
  WithdrawWhitelistModal,
} from 'modals';
import { WalletsImportModal } from 'modals/WalletsImportModal/WalletsImportModal';
import { WithdrawalStatusModal } from 'modals/WithdrawalStatusModal';
import { useTypedSelector } from 'store';
import { ITransfer } from 'types/transfers';
import { ChangePairNetwork } from 'ui/ChangePairNetwork/ChangePairNetwork';

const Modals = () => {
  const pair = useTypedSelector(store => store.pairs.selectedDexPair)!;
  const {
    handleRemount,
    rowSelection,
    selectedRecords,
    modals: {
      connectWalletsOpened,
      disconnectWalletsOpened,
      depositOpened,
      withdrawOpened,
      transferOpened,
      whitelistWithdrawOpened,
      manualTxsOpened,
      changeNetworkOpened,
      withdrawStatusModalOpened,
      importWalletsOpened,
    },
  } = useContext(PairWalletsContext);

  const [withdrawTransfers, setWithdrawTransfers] = useState<ITransfer[]>([]);

  const onSuccessDeactivateWallets = useCallback(() => {
    handleRemount();
    rowSelection.set({});

    //eslint-disable-next-line
  }, [handleRemount]);

  const onWithdrawResult = useCallback((transfers: ITransfer[]) => {
    setWithdrawTransfers(transfers);
    withdrawStatusModalOpened.set(true);

    //eslint-disable-next-line
  }, []);

  return (
    <>
      {connectWalletsOpened.get && (
        <ConnectNewWalletsToPairModal
          onClose={() => connectWalletsOpened.set(false)}
          onOpen={() => connectWalletsOpened.set(true)}
          onSuccess={handleRemount}
          pairId={pair.id}
        />
      )}
      {disconnectWalletsOpened.get && (
        <DisconnectWalletsFromPairModal
          onClose={() => disconnectWalletsOpened.set(false)}
          onOpen={() => disconnectWalletsOpened.set(true)}
          onSuccess={onSuccessDeactivateWallets}
          wallets={selectedRecords}
        />
      )}
      {depositOpened.get && (
        <DepositWithdrawModal
          onClose={() => depositOpened.set(false)}
          onRemountTable={handleRemount}
          wallets={selectedRecords}
          pair={pair}
          type="deposit"
          setManualTxsModalOpened={manualTxsOpened.set}
        />
      )}
      {withdrawOpened.get && (
        <DepositWithdrawModal
          onClose={() => withdrawOpened.set(false)}
          onRemountTable={handleRemount}
          wallets={selectedRecords}
          pair={pair}
          type={'withdraw'}
          setManualTxsModalOpened={manualTxsOpened.set}
          onWithdrawResult={onWithdrawResult}
        />
      )}
      {whitelistWithdrawOpened.get && (
        <WithdrawWhitelistModal onClose={() => whitelistWithdrawOpened.set(false)} />
      )}
      {transferOpened.get && selectedRecords[0] && (
        <ModalTransferWizard
          pair={pair}
          sourceWallet={selectedRecords[0]}
          onClose={() => transferOpened.set(false)}
          onRemountTable={handleRemount}
        />
      )}
      {manualTxsOpened.get && <ManualTxsModal onClose={() => manualTxsOpened.set(false)} />}
      {changeNetworkOpened.get && (
        <ChangePairNetwork onClose={() => changeNetworkOpened.set(false)} />
      )}
      {withdrawStatusModalOpened.get && (
        <WithdrawalStatusModal
          transfers={withdrawTransfers}
          onClose={() => withdrawStatusModalOpened.set(false)}
        />
      )}
      {importWalletsOpened.get && (
        <WalletsImportModal onClose={() => importWalletsOpened.set(false)} isVisibleBots />
      )}
    </>
  );
};

export default Modals;
